<div>
  <header>
    <div class="n-header-container seds-flex seds-items-center">
      <div>
        <seds-header-logo
          [logoImage]="logoImage"
          [smallLogoImage]="smallLogoImage"
          [url]="url"
          [applicationName]="applicationName"></seds-header-logo>
      </div>
      <div class="seds-flex seds-items-center seds-flex-row">
        <div *ngIf="showTimer" class="seds-flex seds-items-center">
          <div class="element-lg element-xl">
            <seds-timer
              #timer
              class="seds-m-2"
              [colorMode]="'default-light'"
              (finishedTime)="onFinishedTime($event)"></seds-timer>
          </div>
        </div>
        <div *ngIf="showBadge" class="seds-flex seds-items-center">
          <div class="element-lg element-xl">
            <seds-badge [counter]="counter" icon="notifications"></seds-badge>
          </div>
        </div>
        <div *ngIf="showUser && userData">
          <seds-header-user
            [userData]="userData"
            colorMode="default-dark"
            (actionButtonMenuClick)="onButtonItemClick($event)"></seds-header-user>
        </div>
      </div>
    </div>
  </header>
  <div *ngIf="showMenu">
    <seds-header-menu [headerMenuList]="headerMenuList"></seds-header-menu>
  </div>
</div>
